import { useEffect, useState } from 'react'

import { useWindowSize } from '../../../../hooks/useWindowSize'
import { Box } from '../../../../shared_components/UI/Box'
import { Notice, PlaceholderBox, PlaceholderContainer } from './styles'

const defaultText = `If you have invested in a project that vests through ZAP, your
        allocations will appear here.`

const NoAllocations = ({ text = defaultText }: { text?: string }) => {
  const [boxAmount, setBoxAmount] = useState(5)

  const { width: screenWidth } = useWindowSize()

  useEffect(() => {
    if (screenWidth >= 1400) {
      setBoxAmount(5)
    } else if (screenWidth >= 1200) {
      setBoxAmount(4)
    } else {
      setBoxAmount(3)
    }
  }, [screenWidth])

  return (
    <Box direction="column">
      <Notice>{text}</Notice>
      <PlaceholderContainer>
        {Array(boxAmount)
          .fill(0)
          .map((_, i) => (
            <PlaceholderBox key={`placeholder-${i}`} />
          ))}
      </PlaceholderContainer>
    </Box>
  )
}

export default NoAllocations
